import axios from "axios";
import { decryptData } from "../utils/decrypt";
import errorAlert from "../views/errors/errorAlert";

const BASE_URL = process.env.REACT_APP_API_URL;

export const getHistorialAccess = async (idCliente) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/log/get-historial-access`
    );
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const adminConfig = async (value) => {
  await axios.post(`${BASE_URL}/auth/admin-query`, value, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export const handleConfigEcfMseller = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/ecf/handle-config`,
      data
    );
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const updateConfigEcfMseller = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/ecf/update-config-mseller`,
      data
    );
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const getConfigEcfMseller = async (data) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/ecf/get-config`,
      data
    );
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

